export default __webpack_public_path__ + "static/media/vendor.f8bb100b.png";